<!--夜间限速-->
<template>
  <div>
    <div class="page_header">
      <span class="page_title">{{ $t("nightSpeedLimit.pageTitle") }}</span>

      <el-form :inline="true" :size="size" style="flex: 1; text-align: right">
        <el-form-item :label="$t('public.vehicleInput')">
          <el-input clearable v-model="form.QueryKey" style="width: 210px"
            :placeholder="$t('public.vehicleInputTips')"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            $t("public.query")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onPatchSetClick" plain>{{
            $t("public.BatchSet")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="page_container">
      <div style="max-height: calc(100vh - 240px); overflow: auto">
        <el-table v-loading="loading" :size="size" :data="list" @selection-change="handleSelectionChange" border
          style="width: 100%">
          <el-table-column type="selection" align="center" width="55">
          </el-table-column>

          <el-table-column prop="CarNo" align="center" :label="$t('vehicle.carNo')">
          </el-table-column>

          <el-table-column prop="OldLimitSpeed" align="center" :label="$t('nightSpeedLimit.currentLimit') + '(km/h)'">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.limitspeed }}
            </template>
          </el-table-column>
          <el-table-column prop="OldLimitBeginTime" align="center" :label="$t('nightSpeedLimit.限速开始时间')">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.limitBeginTime }}
            </template>
          </el-table-column>
          <el-table-column prop="OldLimitEndTime" align="center" :label="$t('nightSpeedLimit.限速结束时间')">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.limitEndTime }}
            </template>
          </el-table-column>
          <el-table-column prop="OldRemindDuration" align="center" :label="$t('nightSpeedLimit.earlyWarningTime') +
            '(' +
            $t('time.minute') +
            ')'
            ">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.remindduration }}
            </template>
          </el-table-column>
          <el-table-column prop="OldRemindInterval" align="center" :label="$t('nightSpeedLimit.warningInterval') +
            '(' +
            $t('time.minute') +
            ')'
            ">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.remindinterval }}
            </template>
          </el-table-column>
          <el-table-column prop="OldRemindContent" align="center" :label="$t('nightSpeedLimit.warningContent')">
            <template slot-scope="scope">
              {{ scope.row.oldlimitsetinfo.remindcontent }}
            </template>
          </el-table-column>

          <el-table-column prop="OperatorName" align="center" :label="$t('public.Operation')">
            <template slot-scope="scope">
              <el-link :underline="false" @click="onSetClick(scope.row)" type="primary">{{ $t("public.Set") }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="DealState" align="center" :label="$t('public.SetStatus')">
            <template slot-scope="scope">
              {{ showDBSetInfo(scope.row) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <kl-pagination style="margin-bottom: 10px" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo">
      </kl-pagination>
    </div>
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px">
      <div style="padding: 0 20px">
        <div style="text-align: left">
          <div style="margin-bottom: 16px; display: flex">
            <span style="
                flex: 1;
                font-weight: bold;
                font-size: 12px;
                color: #0f1a3a;
              ">{{ $t("nightSpeedLimit.nightRunSpeedLimit") }}</span>
            <el-radio-group v-model="isOpenLimit" :size="size">
              <el-radio :label="1">{{ $t('public.open') }}</el-radio>
              <el-radio :label="2">{{ $t('public.close') }}</el-radio>
            </el-radio-group>
          </div>
          <el-form :size="size" label-width="100px">
            <el-form-item v-if="setType == 2" :label="$t('vehicle.carNo')">
              <el-input v-model="CarNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('nightSpeedLimit.限速时间')">

              <div style="display: flex; align-items: center;text-align: left;"> <el-time-picker v-model="beginTime"
                  :placeholder="$t('nightSpeedLimit.限速开始时间')" style="width: 160px;">
                </el-time-picker> - <el-time-picker v-model="endTime" :placeholder="$t('nightSpeedLimit.限速结束时间')" style="width: 160px;"> 
                </el-time-picker></div>
            </el-form-item>
            <limitvalueset v-model="LimitSpeed" :label="$t('arealimitset.limitvalue')" unit="0～100km/h" :min="0"
              :max="100" />
            <limitvalueset v-model="RemindDuration" :label="$t('nightSpeedLimit.earlyWarningTime')"
              :unit="$t('time.minute')" />
            <limitvalueset v-model="RemindInterval" :label="$t('nightSpeedLimit.warningInterval')"
              :unit="$t('time.minute')" />
            <el-form-item :label="$t('nightSpeedLimit.warningContent')">
              <el-input type="textarea" v-model="RemindContent"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="size">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="saveConfig" :size="size">{{
          $t("public.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import limitvalueset from "./components/limitvalueset";
export default {
  name: "time_speed_set",
  components: {
    limitvalueset,
  },
  data() {
    return {
      beginTime: new Date(2020, 1, 1, 2, 0),
      endTime: new Date(2020, 1, 1, 5, 0),
      dialogVisible: false,
      date: [],
      loading: false,
      isOpenLimit: 1,
      form: {
        CompanyID: 0,
        OperatorID: 0,
        CarNo: "",
        DeviceNo: "",
        ManufactureID: "",
        QueryKey: "",
        PageNo: 1,
        PageSize: 10,
      },
      CarNo: "",
      LimitSpeed: 60,
      RemindDuration: 30,
      RemindInterval: 10,
      RemindContent: "",
      tableData: [],
      dataList: [],
      total: 0,
      dialogTitle: this.$t("public.Set"),
      multipleSelection: [],
      deleteId: [],
      setType: 0, //1 批量设置 2单车设置
      currentRow: undefined,
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
    list() {
      if (this.dataList != null && this.dataList.length > 0) {
        return this.dataList.slice(
          (this.form.PageNo - 1) * this.form.PageSize,
          this.form.PageNo * this.form.PageSize
        );
      }
    },
  },
  methods: {
    showDBSetInfo(row) {
      var result = "";
      if (row.RespResult == "" || row.RespResult == null) {
        //正在设置中
        //发送数据超过或者等于30，表示设置失败
        //不然就是正在下发

        result += this.$t("nightSpeedLimit.sendingnightSpeedLimit") + "： ";
        if (row.SendCount == 30) {
          result += this.$t("public.Fail");
        } else {
          if (row.limitsetinfo) {
            if (row.limitsetinfo.limitspeed == "未设置") {
              result = "";
            } else if (row.limitsetinfo.limitspeed == "关闭夜间限速") {
              result += this.$t("nightSpeedLimit.closenightSpeedLimit");
            } else {
              result +=
                this.$t("arealimitset.limitvalue") +
                ":" +
                row.limitsetinfo.limitspeed +
                "km/h;" +
                this.$t("nightSpeedLimit.Durationofvoicereminder") +
                "：" +
                row.limitsetinfo.remindduration +
                this.$t("time.minute") +
                "，" +
                this.$t("nightSpeedLimit.voicereminderInterval") +
                "：" +
                row.limitsetinfo.remindinterval +
                this.$t("time.minute") +
                "，" +
                this.$t("nightSpeedLimit.voicereminderContent") +
                "：" +
                row.limitsetinfo.remindcontent +
                "，" +
                this.$t("nightSpeedLimit.限速时间") +
                "：(" +
                row.limitsetinfo.limitBeginTime +
                "~" +
                row.limitsetinfo.limitEndTime +
                ")";
            }
          }
        }
      }
      return result;
    },
    saveConfig() {
      var ids = "";
      if (this.setType == 1) {
        ids = this.deleteId.join(",");
      } else {
        ids = this.currentRow.VehicleID;
      }
      if (this.isOpenLimit == 2) {
        //关闭夜间行车限速
        this.LimitSpeed = 255;
        this.RemindInterval = 10;
        this.RemindDuration = 30;
        this.beginTime = new Date(2020, 1, 1, 2, 0);
        this.endTime = new Date(2020, 1, 1, 5, 0);
      }
      //this.beginTime 格式化为 hh:mm:ss

      this.$api
        .setNightSpeedLimit({
          OperatorID: this.operator.OperatorId,
          LimitSpeedValue: this.LimitSpeed,
          LimitSpeedRemindValue: this.RemindInterval,
          content: this.RemindContent,
          RemindDuration: this.RemindDuration,
          vid: ids.toString(),
          IsRemind: this.isOpenLimit == 1 ? 1 : 0,
          limitBeginTime: this.moment(
            this.beginTime
          ).format("HH:mm:ss"),
          limitEndTime: this.moment(
            this.endTime
          ).format("HH:mm:ss"),
        })
        .then((res) => {
          console.log(res);
          //成功提示
          this.$message({
            type: "success",
            message: this.$t("public.SetSuccess"),
          });
          this.queryList();
          this.dialogVisible = false;
        })
        .catch(() => {
          //失败提示
          this.$message({
            type: "error",
            message: this.$t("public.SetFail"),
          });
        });
      //提交接口保存
    },

    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      console.log(selection);
      this.deleteId = selection.map((item) => item.VehicleID);
      console.log(this.deleteId);
    },
    onSetClick(row) {
      this.currentRow = row;
      // this.speed = row.SetLimitSpeed;
      this.setType = 2; //单车设置
      this.isOpenLimit = 1;
      this.CarNo = row.CarNo;
      this.LimitSpeed = 60;
      this.RemindDuration = 30;
      this.RemindInterval = 10;
      this.beginTime = new Date(2020, 1, 1, 2, 0);
      this.endTime = new Date(2020, 1, 1, 5, 0);
      this.RemindContent = this.$t("nightSpeedLimit.tishi");

      this.dialogTitle = this.$t("hightlimit.SingleLimitSet");
      this.dialogVisible = true;
    },
    onPatchSetClick() {
      //批量设置
      if (this.deleteId.length == 0) {
        this.$message({
          type: "warning",
          message: this.$t("public.PlsSelectSetVehicles"),
        });
        return;
      }
      this.setType = 1; //批量设置
      this.LimitSpeed = 60;
      this.RemindDuration = 30;
      this.RemindInterval = 10;
      this.beginTime = new Date(2020, 1, 1, 2, 0);
      this.endTime = new Date(2020, 1, 1, 5, 0);
      this.RemindContent = this.$t("nightSpeedLimit.tishi");

      this.dialogTitle = this.$t("public.BatchSet");
      this.dialogVisible = true;
    },
    pageChange(page) {
      this.form.PageNo = page;
      this.queryList();
    },
    init() {
      //初始化查询条件
      //查询日期，最近7天

      var now = this.moment(); //今天
      var prev = this.moment().subtract(7, "days"); //7天前

      this.date = [prev, now];

      this.form.OperatorID = this.operator.OperatorId;
      this.form.CompanyID = this.operator.CompanyId;
    },
    queryList() {
      this.tableData = [];
      this.dataList = [];

      this.loading = true;
      this.$api
        .queryNightSpeedLimitSetRec(this.form)
        .then((res) => {
          this.loading = false;
          if (res && res.code == 200) {
            //本地分页
            this.dataList = res.data;

            this.total = res.data.length;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      //整理查询字段

      this.form.BeginTime = this.moment(this.date[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.form.EndTime = this.moment(this.date[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      this.form.PageNo = 1;

      this.queryList();
    },
  },
  mounted() {
    this.init();
    this.queryList();
  },
};
</script>
<style scoped lang="scss"></style>
